import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, ShieldStar, ArrowUpRight } from "@phosphor-icons/react";

// Legacy Challenge signup pop-up.
// - Shows to every new visitor (per browser) after a 4s delay.
// - Once dismissed or actioned, stays hidden for the rest of that browsing session.
// - Bumped the storage key (v3) so anyone who dismissed a prior version sees it fresh.
const SESSION_KEY = "sws_legacy_splash_dismissed_v3";
const DELAY_MS = 4000;

export default function LegacySplash() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let dismissed = false;
    try {
      // sessionStorage only — pop-up returns for the next browsing session so we
      // don't lose returning visitors who haven't signed up yet.
      dismissed = sessionStorage.getItem(SESSION_KEY) === "1";
    } catch { /* private mode: still show */ }
    if (dismissed) return;
    const t = setTimeout(() => setVisible(true), DELAY_MS);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    setVisible(false);
    try { sessionStorage.setItem(SESSION_KEY, "1"); } catch { /* ignore */ }
  };

  if (!visible) return null;

  return (
    <div
      data-testid="legacy-splash"
      role="dialog"
      aria-label="Sweat for Sacrifice Legacy Challenge signup"
      className="fixed inset-x-0 bottom-0 md:inset-auto md:bottom-6 md:right-6 z-[70] md:max-w-sm animate-in fade-in slide-in-from-bottom-6 duration-300"
    >
      <div className="bg-[#0A0A0A] border-2 border-[#B32027] shadow-[0_0_40px_rgba(179,32,39,0.4)] relative">
        <button
          onClick={dismiss}
          data-testid="legacy-splash-close"
          className="absolute top-2 right-2 w-9 h-9 flex items-center justify-center text-white/70 hover:text-white transition-colors"
          aria-label="Dismiss Legacy Challenge signup pop-up"
        >
          <X size={18} weight="bold" />
        </button>
        <div className="p-5 md:p-6">
          <div className="flex items-center gap-2 mb-3">
            <ShieldStar size={18} weight="fill" className="text-[#B32027]" />
            <span className="text-[#B32027] uppercase tracking-[0.35em] text-[10px] font-bold">
              / Inaugural challenge
            </span>
          </div>
          <p className="font-brush text-3xl md:text-4xl text-[#B32027] -rotate-2 inline-block mb-2">
            Who are you moving for?
          </p>
          <h3 className="font-display font-black uppercase tracking-tighter text-2xl md:text-3xl leading-[0.9] mt-1">
            Sweat for<br />
            <span className="text-[#B32027]">Sacrifice.</span>
          </h3>
          <p className="mt-3 text-white/85 text-sm leading-relaxed">
            The 9/11 Legacy Challenge · 911 minutes of movement · every minute carries a name.
          </p>
          <div className="mt-5 flex flex-col sm:flex-row gap-2">
            <Link
              to="/sweat-for-sacrifice#signup"
              onClick={dismiss}
              data-testid="legacy-splash-cta"
              className="inline-flex items-center justify-center gap-2 bg-[#B32027] hover:bg-[#D42730] text-white px-4 py-3 text-[10px] font-bold uppercase tracking-[0.25em] transition-colors flex-1"
            >
              Sign up for the challenge <ArrowUpRight size={12} weight="bold" />
            </Link>
            <button
              onClick={dismiss}
              data-testid="legacy-splash-later"
              className="text-white/70 hover:text-white text-[10px] font-bold uppercase tracking-[0.25em] px-4 py-3 transition-colors border border-white/15 hover:border-white/40"
            >
              Maybe later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
